/* eslint-disable max-len */
import React from 'react';

const CitiesIcon: React.FC<object> = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_9342_253397)">
                <path
                    d="M15.3333 7.99935C15.3333 12.0494 12.05 15.3327 7.99996 15.3327C3.94987 15.3327 0.666626 12.0494 0.666626 7.99935C0.666626 3.94926 3.94987 0.666016 7.99996 0.666016C12.05 0.666016 15.3333 3.94926 15.3333 7.99935Z"
                    stroke="currentColor"
                />
                <path
                    d="M10.6667 7.99935C10.6667 12.0494 9.4728 15.3327 8.00004 15.3327C6.52728 15.3327 5.33337 12.0494 5.33337 7.99935C5.33337 3.94926 6.52728 0.666016 8.00004 0.666016C9.4728 0.666016 10.6667 3.94926 10.6667 7.99935Z"
                    stroke="currentColor"
                />
                <path
                    d="M8.00004 10.6673C3.94995 10.6673 0.666707 9.47341 0.666707 8.00065C0.666707 6.52789 3.94995 5.33398 8.00004 5.33398C12.0501 5.33398 15.3334 6.52789 15.3334 8.00065C15.3334 9.47341 12.0501 10.6673 8.00004 10.6673Z"
                    stroke="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_9342_253397">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default CitiesIcon;